// extracted by mini-css-extract-plugin
export default {"averagesDiv":"SpendMetrics_averagesDiv__E65Lb","typicalSpend":"SpendMetrics_typicalSpend__to4Zt","belowTypical":"SpendMetrics_belowTypical__Uq-yu"};